import React, { useContext, useEffect, useRef, useState } from "react";
import clockImg from "../../../assets/images/clock.svg";
import { GlobalContext } from "../../../context/Provider";

const DealsTimer = ({ valid_till }: { valid_till: number }) => {
    const { authState } = useContext(GlobalContext);
    const intervalRef = useRef<any>(null);

    const [timerCount, setTimerCount] = useState({
        days: "0",
        hours: "0",
        minutes: "0",
        seconds: "0",
    });

    // Helper to pad numbers
    const pad = (num: number) => String(num).padStart(2, "0");

    const startTimer = (endDate: number) => {
        // Clear any existing interval
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        // If no valid end date, reset timer and return
        if (!endDate || endDate <= Date.now()) {
            setTimerCount({ days: "0", hours: "0", minutes: "0", seconds: "0" });
            return;
        }

        const _second = 1000;
        const _minute = _second * 60;
        const _hour = _minute * 60;
        const _day = _hour * 24;
        const end = new Date(endDate);

        const updateTimer = () => {
            const now = new Date();
            let distance = end.getTime() - now.getTime();

            if (distance <= 0) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                setTimerCount({ days: "0", hours: "0", minutes: "0", seconds: "0" });
                return;
            }

            const days = Math.floor(distance / _day);
            const hours = Math.floor((distance % _day) / _hour);
            const minutes = Math.floor((distance % _hour) / _minute);
            const seconds = Math.floor((distance % _minute) / _second);

            setTimerCount({
                days: pad(days),
                hours: pad(hours),
                minutes: pad(minutes),
                seconds: pad(seconds),
            });
        };

        // Update immediately to avoid 1-second delay
        updateTimer();
        // Then start interval
        intervalRef.current = setInterval(updateTimer, 1000);
    };

    useEffect(() => {
        startTimer(valid_till);

        // Cleanup on unmount or when valid_till changes
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valid_till, authState?.lang]); // Re-run when language changes too

    return (
        <div className="deal-time">
            <ul className="list-unstyled mb-0 ps-0 d-flex align-items-center">
                <img src={clockImg} className="me-2" alt="clock" />
                {timerCount.days} : {timerCount.hours} : {timerCount.minutes} : {timerCount.seconds} Left
            </ul>
        </div>
    );
};

export default DealsTimer;